export default {
      id: "ic-play-24px-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.c2f64a3b.svg#ic-play-24px",
      toString: function () {
        return this.url;
      }
    }